import { FC, HTMLAttributes, useState } from 'react';
import InputBase from '..';
import { InputBackgroundType } from '../inputConfig';

const TextInput: FC<{
  /**
   * dataTestId for E2E testing
   */
  dataTestId?: string;

  /**
   * Name of the input
   */
  name?: string;

  /**
   * Value of the input
   */
  value: string;

  /**
   * Label for the input
   */
  label?: string;
  inputType?: 'text' | 'email' | 'tel';

  /**
   * Explainer text for the input
   */
  assistiveMessage?: string;
  errorMessage?: string | undefined | null;
  placeholder: string;
  onChange: (value: string) => void;
  onBlur?: (() => void) | undefined;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  required: boolean;
  disabled: boolean;
  className?: string;
  hideAssistiveMessage?: boolean;
  backgroundType?: InputBackgroundType;
  maxLength?: number;
  autoCapitalize?: HTMLAttributes<HTMLInputElement>['autoCapitalize'];
}> = ({
  maxLength,
  dataTestId,
  name,
  value,
  label,
  inputType = 'text',
  assistiveMessage,
  errorMessage,
  placeholder,
  onChange,
  onBlur,
  onKeyDown,
  /**
   * Whether the input is required
   *
   * We don't use default values to make it explicit and avoid bugs
   */
  required,

  /**
   * Whether the input is disabled
   *
   * We don't use default values to make it explicit and avoid bugs
   */
  disabled,
  className,
  hideAssistiveMessage = false,
  backgroundType = 'DARK',
  autoCapitalize
}) => {
  const [isTyping, setIsTyping] = useState(false);

  return (
    <InputBase
      inputComponent={
        <input
          autoCapitalize={autoCapitalize}
          maxLength={maxLength}
          data-test-id={dataTestId}
          name={name}
          type={inputType}
          value={value}
          className="body-01 w-full px-spacing-02 py-[6px] text-primary outline-hidden placeholder:text-tertiary disabled:text-tertiary bg-transparent"
          placeholder={placeholder}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          onFocus={() => {
            setIsTyping(true);
          }}
          onBlur={() => {
            setIsTyping(false);
            onBlur?.();
          }}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
      }
      label={label}
      assistiveMessage={assistiveMessage}
      required={required}
      disabled={disabled}
      isBeingUpdated={isTyping}
      errorMessage={errorMessage}
      className={className}
      hideAssistiveMessage={hideAssistiveMessage}
      backgroundType={backgroundType}
    />
  );
};

export default TextInput;
